import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLink: false, // 是否连接
};

const socketStatusSlice = createSlice({
  name: 'socket',
  initialState,
  reducers: {
    toggleLinkStatus(state, action) {
      state.isLink = action.payload;
    },
  },
});

export const { toggleLinkStatus } = socketStatusSlice.actions;
export default socketStatusSlice.reducer;
